import * as React from "react";

const TabSection: React.FunctionComponent<{ active: boolean }> = (props) => {
  return props.active ? <div className={`tab-section`}>{props.children}</div> : null;
};

export default TabSection;
